import React from 'react';
// resolved from style-guide
// eslint-disable-next-line import/no-extraneous-dependencies
import { toKeyName } from 'is-hotkey';
import MarkButton from '@tmap/mmm-style-guide/src/slate/markButton';
import LinkButton from '@tmap/mmm-style-guide/src/slate/linkButton';
import RichToolbar from '@tmap/mmm-style-guide/src/slate/richToolbar';
import StyledToggleButtonGroup from '@tmap/mmm-style-guide/src/slate/styledToggleButtonGroup';
import { FormatBold, FormatItalic, FormatUnderlined } from '@tmap/mmm-style-guide/src/Icon';
import { Tooltip } from '@tmap/mmm-style-guide/src/Tooltip';
import { LINK_TYPE } from '@tmap/mmm-style-guide/src/slate/constants';

import {
  MATCH_URL_YOUTUBE,
  MATCH_URL_SOUNDCLOUD,
  MATCH_URL_VIMEO,
  MATCH_URL_FACEBOOK,
  MATCH_URL_FACEBOOK_WATCH,
  MATCH_URL_STREAMABLE,
  MATCH_URL_WISTIA,
  MATCH_URL_TWITCH_VIDEO,
  MATCH_URL_TWITCH_CHANNEL,
  MATCH_URL_DAILYMOTION,
  MATCH_URL_MIXCLOUD,
  MATCH_URL_VIDYARD,
  MATCH_URL_KALTURA,
  // resolved through a package.json export
  // eslint-disable-next-line import/no-unresolved
} from 'react-player/patterns';

const videoPatterns = [
  MATCH_URL_YOUTUBE,
  MATCH_URL_SOUNDCLOUD,
  MATCH_URL_VIMEO,
  MATCH_URL_FACEBOOK,
  MATCH_URL_FACEBOOK_WATCH,
  MATCH_URL_STREAMABLE,
  MATCH_URL_WISTIA,
  MATCH_URL_TWITCH_VIDEO,
  MATCH_URL_TWITCH_CHANNEL,
  MATCH_URL_DAILYMOTION,
  MATCH_URL_MIXCLOUD,
  MATCH_URL_VIDYARD,
  MATCH_URL_KALTURA,
];

const platformPrefix = toKeyName('mod') === 'meta' ? '⌘' : 'ctrl';

function TextToolbar(props) {
  return (
    <StyledToggleButtonGroup size='small' arial-label='text formatting' {...props}>
      <Tooltip title={`Bold (${platformPrefix}+b)`}><MarkButton format='bold' Icon={FormatBold} /></Tooltip>
      <Tooltip title={`Italic (${platformPrefix}+i)`}><MarkButton format='italic' Icon={FormatItalic} /></Tooltip>
      <Tooltip title={`Underline (${platformPrefix}+u)`}><MarkButton format='underline' Icon={FormatUnderlined} /></Tooltip>
      <Tooltip title='Toggle Link'><LinkButton /></Tooltip>
    </StyledToggleButtonGroup>
  );
}

TextToolbar.hotkeys = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
};

TextToolbar.hookPaste = (handleMediaPaste) => {
  TextToolbar.onPaste = (event, editor) => {
    // since the ReactPlayer regex only work for testing (not finding) urls,
    // we let the default rich paste handle link identification in a text paste
    const richLinkPaste = RichToolbar.onPaste(event, editor);
    if (richLinkPaste) {
      const lastAction = editor.history.undos[editor.history.undos.length - 1];
      const insertedLinks = lastAction.operations.reduce((accum, op) => {
        if (op.type === 'insert_node' && op.node.type === LINK_TYPE) {
          return accum.concat(op.node.url);
        }
        return accum;
      }, []);
      insertedLinks.forEach((link) => {
        const isVideo = videoPatterns.some((pattern) => pattern.test(link));
        if (isVideo) handleMediaPaste({ type: 'videoEmbed', url: link });
      });
    }
    return richLinkPaste;
  };
  return TextToolbar;
};

export default TextToolbar;
